import React, { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { useDispatch, useSelector } from "react-redux";
import { Button, Form } from "react-bootstrap";
import { IoIosEye, IoIosEyeOff } from "react-icons/io";
import { AuthModals } from "../../../config/const";
import LoaderCircle from "../../../assets/images/loader.webp";
import { checkIfDemoUserExist } from "../../../redux/app/actions";
import { demoLogin, loginUser } from "../../../redux/auth/actions";
import useAuthModalHook from "../../../hooks/useAuthModalHook";

const LoginModal = ({ show }) => {
  const dispatch = useDispatch();
  const { updateActiveAuthModal } = useAuthModalHook();
  const [showPassword, setShowPassword] = useState(false);
  const [formData, setFormData] = useState({});
  const { appDetails } = useSelector((state) => state.app);
  const [errors, setErrors] = useState({});
  const isOtpRequired = useSelector(
    (state) => state?.app?.appDetails?.OTP === 0
  );
  const [isDemoUserExist, setIsDemoUserExist] = useState(false);
  const [loaders, setLoaders] = useState({
    login: false,
    demoLogin: false,
  });

  useEffect(() => {
    checkDemoUser();
  }, []);

  /**
   *
   * @param {string} keyName
   * @param {boolean} booleanValue
   */
  const updateLoaders = (keyName, booleanValue) => {
    setLoaders((p) => ({ ...p, [keyName]: booleanValue }));
  };

  const checkDemoUser = async () => {
    const response = await checkIfDemoUserExist();
    if (response && response?.data?.error === false) {
      setIsDemoUserExist(response?.data?.data?.hasDemoUsers === true);
    }
  };

  const validateData = () => {
    const { username, password } = formData;
    const newErrors = {};
    if (!username || username === "") {
      newErrors.username = "Phone or Username can not be empty";
    }
    if (!password || password === "") {
      newErrors.password = "Password cannot be empty";
    }
    return newErrors;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const errorData = validateData();

    if (Object.keys(errorData).length > 0) {
      setErrors(errorData);
    } else {
      updateLoaders("login", true);
      let loginData = { ...formData };
      // handleClose();
      dispatch(
        loginUser(loginData, () => {
          updateLoaders("login", false);
        })
      );
    }
  };

  const handleChange = (e) => {
    let fieldName = e.target.name;
    let fieldValue = e.target.value;
    let tempFormData = { ...formData, [fieldName]: fieldValue };
    setFormData(tempFormData);
  };

  const loginDemoUser = (e) => {
    e.preventDefault();
    updateLoaders("demoLogin", true);
    dispatch(
      demoLogin(() => {
        updateLoaders("demoLogin", false);
      })
    );
  };

  return (
    <Modal
      show={show}
      id="loginModal"
      className={"steps-canvas login-register login"}
      onHide={() => {
        console.log("working");
      }}
      placement={"end"}
      centered
    >
      <Modal.Header
        closeButton
        onClick={() => updateActiveAuthModal(null)}
        closeVariant="black"
      >
        <div className="img-box">
          <img src={appDetails?.LOGO_URL} alt="Logo" />
        </div>
      </Modal.Header>
      <Modal.Body>
        <div className="inner-wrapper">
          <h2 className="title">Welcome Back, Login</h2>

          <Form>
            <Form.Group className="form-group">
              {/* <Form.Label htmlFor="formBasicName">Username</Form.Label> */}
              <Form.Control
                type="text"
                name="username"
                placeholder="Enter Username"
                onChange={handleChange}
                isInvalid={!!errors.username}
              />
              <Form.Control.Feedback type="invalid">
                {errors?.username}
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group className="form-group">
              {/* <Form.Label htmlFor="formBasicName1">Password</Form.Label> */}
              <Form.Control
                type={showPassword ? "text" : "password"}
                placeholder="Password*"
                name="password"
                onChange={handleChange}
                isInvalid={!!errors.password}
              />
              <span className="icon" onClick={() => setShowPassword((s) => !s)}>
                {showPassword ? <IoIosEyeOff /> : <IoIosEye />}
              </span>
              <Form.Control.Feedback type="invalid">
                {errors?.password}
              </Form.Control.Feedback>
            </Form.Group>

            {isOtpRequired && (
              <a
                className="form-link frgt"
                onClick={() => {
                  updateActiveAuthModal(AuthModals.ForgotPassword);
                }}
              >
                Forgot password?
              </a>
            )}

            <div className="group-btns">
              <Button
                variant="primary"
                type="submit"
                onClick={handleSubmit}
                disabled={loaders?.login}
              >
                {loaders?.login ? "Loading..." : "Login"}
              </Button>
              {!isDemoUserExist ? (
                <Button variant="primary">
                  {/* <img src={LoaderCircle} style={{ width: "20px" }} /> */}
                  Loading...
                </Button>
              ) : (
                isDemoUserExist && (
                  <>
                    <Button
                      variant="primary"
                      className="demo-login"
                      onClick={loginDemoUser}
                      disabled={loaders?.demoLogin}
                    >
                      {loaders?.demoLogin
                        ? // <img src={LoaderCircle} style={{ width: "30px" }} />
                          "Loading..."
                        : "Demo Login"}
                    </Button>
                  </>
                )
              )}
            </div>
          </Form>

          <div className="signin-signup">
            Don’t have an account?{" "}
            <a
              href="javascript:void(0)"
              onClick={() => {
                updateActiveAuthModal(AuthModals.MobileNumber);
              }}
            >
              Sign Up
            </a>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};
export default LoginModal;
